import { Routes } from '@angular/router';
import { AuthGuard } from './auth-guard.service';
import { HomeComponent } from './home/pages/home/home.component';
import { SenhaAlterarComponent } from './auth/pages/senha-alterar/senha-alterar.component';
import { SearchListComponent } from './buy/pages/search/search-list/search-list.component';
import { KitDetailsComponent } from './buy/pages/kit-details/kit-details.component';
import { BookUploadComponent } from './book-create/book-upload/book-upload.component';
import { BookPrintComponent } from './book-create/book-print/book-print.component';
import { BookDetailsComponent } from './book-create/book-details/book-details.component';
import { BookStatusComponent } from './book-create/book-status/book-status.component';
import { BookPaymentComponent } from './book-create/book-payment/book-payment.component';
import { ShoppingCartComponent } from './buy/pages/shopping-cart/shopping-cart.component';
import { KitPaymentComponent } from './buy/pages/kit-payment/kit-payment.component';
import { KitPaymentSuccessComponent } from './buy/pages/kit-payment-success/kit-payment-success.component';
import { MyBooksComponent } from './my-books/my-books.component';
import { BookPublishEditComponent } from './my-books/book-publish-edit.component/book-publish-edit.component';
import { BookApproveComponent } from './book-create/book-approve/book-approve.component';
import { MyShoppingComponent } from './buy/pages/my-shopping/my-shopping.component';
import { MyShoppingItemComponent } from './buy/pages/my-shopping-item/my-shopping-item.component';
import { BookSalesAnalyticsComponent } from './my-books/book-sales-analytics.component/book-sales-analytics.component';
import { AuthorSettingsComponent } from './settings/pages/author-settings.component';
import { WalletComponent } from './wallet/pages/wallet.component';
import { MyShoppingVideosComponent } from './buy/pages/my-shopping-videos/my-shopping-videos.component';
import { UserPermissionListComponent } from './admin/pages/user-permission-list/user-permission-list.component';
import { UserPermissionNewComponent } from './admin/pages/user-permission-new/user-permission-new.component';
import { AdminReviewerComponent } from './admin/pages/admin-reviewer/admin-reviewer.component';
import { AdminReviewerEditComponent } from './admin/pages/admin-reviewer-edit/admin-reviewer-edit.component';
import { SalesListComponent } from './admin/pages/sales-list/sales-list.component';
import { AdminPrintCompanyListComponent } from './admin/pages/admin-print-company-list/admin-print-company-list.component';
import { AdminWithdrawalComponent } from './admin/pages/admin-withdrawal/admin-withdrawal.component';
import { AdminBookPublicationComponent } from './admin/pages/admin-book-publication/admin-book-publication.component';
import { BookCoverStyleComponent } from './book-create/book-cover/book-cover-style.component';
import { AdminBookEditorComponent } from './admin/pages/admin-book-editor/admin-book-editor.component';
import { AdminBookEditorEditComponent } from './admin/pages/admin-book-editor-edit/admin-book-editor-edit.component';
import { BookSimulatorComponent } from './book-create/book-simulator/book-simulator.component';
import { AdminUserListComponent } from './admin/pages/admin-user-list/admin-user-list.component';

// prettier-ignore
export const routes: Routes = [
    { path: '', component: HomeComponent, pathMatch: 'full' },
    { path: 'simular', component: BookSimulatorComponent },
    { path: 'recuperar-senha/:token', component: SenhaAlterarComponent },
    { path: 'livros', component: SearchListComponent },
    { path: 'meus-livros', component: MyBooksComponent },
    { path: 'editar-publicacao/:idBookVersion', component: BookPublishEditComponent },
    { path: 'novo-livro', component: BookUploadComponent },
    { path: 'novo-livro/:idBookVersion', component: BookUploadComponent },
    { path: 'livro-capa/:idBookVersion', component: BookCoverStyleComponent },
    { path: 'livro-impressao/:idBookVersion', component: BookPrintComponent },
    { path: 'livro-pagamento/:idBookVersion', component: BookPaymentComponent },
    { path: 'livro-detalhes/:idBookVersion', component: BookDetailsComponent },
    { path: 'livro-status/:idBookVersion', component: BookStatusComponent },
    { path: 'livro-aprovacao/:idBookVersion', component: BookApproveComponent },
    { path: 'livro/:idKit/:nome', component: KitDetailsComponent },
    { path: 'relatorio/:idBookVersion', component: BookSalesAnalyticsComponent },
    { path: 'carrinho', component: ShoppingCartComponent },
    { path: 'comprar', component: KitPaymentComponent },
    { path: 'sucesso-pagamento', component: KitPaymentSuccessComponent },
    { path: 'minhas-compras', component: MyShoppingComponent },
    { path: 'minhas-compras/:idKitPaymentItem', component: MyShoppingItemComponent },
    { path: 'minhas-compras/videos/:idKit', component: MyShoppingVideosComponent },
    { path: 'config', component: AuthorSettingsComponent },
    { path: 'carteira', component: WalletComponent },
    { path: 'usuarios-admin', component: UserPermissionListComponent },
    { path: 'lista-usuarios-admin', component: AdminUserListComponent },
    { path: 'usuarios-admin/novo', component: UserPermissionNewComponent },
    { path: 'vendas-admin', component: SalesListComponent },
    { path: 'grafica-admin', component: AdminPrintCompanyListComponent },
    { path: 'financeiro-admin', component: AdminWithdrawalComponent },
    { path: 'revisor', component: AdminReviewerComponent },
    { path: 'publicar', component: AdminBookPublicationComponent },
    { path: 'revisor/:idBookVersion', component: AdminReviewerEditComponent },
    { path: 'usuarios-admin/novo/:idUser', component: UserPermissionNewComponent },
    { path: 'editor-admin', component: AdminBookEditorComponent },
    { path: 'editor-admin/:idBookVersion', component: AdminBookEditorEditComponent }
];
